import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import { createCustomRouter } from '@/router'

import axios from 'axios'
axios.defaults.baseURL = import.meta.env.VITE_API_PATH

import { useRemember } from '@/composables/remember'

import App from '@/App.vue'

import CookieConsentVue from '@/plugins/CookieConsentVue'
import VueGtag, { trackRouter } from 'vue-gtag-next'

import ToastPlugin from 'vue-toast-notification'

import ContentContainer from './components/base/ContentContainer.vue'
import HeaderTitle from './components/layout/HeaderTitle.vue'

import '@/assets/style/fonts.css'
import '@/assets/style/article.css'
import '@/assets/style/toast.css'

/**
 * Application creation
 */

const app = createApp(App)

// Global components
// eslint-disable-next-line vue/multi-word-component-names
app.component('Container', ContentContainer)
app.component('HeaderTitle', HeaderTitle)

// Pinia
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app.use(pinia)

// Plugins
app.use(CookieConsentVue)
app.use(VueGtag)
app.use(ToastPlugin)

/**
 * Application initialization
 */

async function initializeApp() {
    // Restore and validate the persisted auth session
    const { remember } = useRemember()
    await remember()

    // Create and install router
    const router = createCustomRouter()
    app.use(router)

    // Initialize Google Analytics route tracking
    trackRouter(router)

    // Wait for initial navigation
    await router.isReady()

    // Mount application
    app.mount('#app')
}

initializeApp()
